import { AssessmentAnalytics } from './AssessmentAnalytics'
import { AssessmentInfoCards } from './AssessmentInfoCards'
import { ConnectedAssessmentQuestionsTable } from './ConnectedAssessmentQuestionsTable'
import type { DetailedAssessment } from '../types'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'

interface AssessmentDetailsProps {
  assessment: DetailedAssessment
}

export function AssessmentDetails({ assessment }: AssessmentDetailsProps) {
  return (
    <div className="space-y-4">
      {/* Row 1: Assessment Info and Score Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <AssessmentInfoCards assessment={assessment} />
        <div className="grid grid-cols-2 gap-4">
          <AssessmentAnalytics
            assessmentId={assessment.id}
            showOnlyScoreCards
          />
        </div>
      </div>

      {/* Tabs for Summary and Survey Results */}
      <Tabs defaultValue="summary" className="w-full">
        <TabsList className="grid w-full max-w-md grid-cols-2">
          <TabsTrigger value="summary">Summary</TabsTrigger>
          <TabsTrigger value="survey">Survey Result</TabsTrigger>
        </TabsList>

        {/* Tab 1: Summary - Will be rendered by AssessmentAnalytics */}
        <TabsContent value="summary" className="mt-2">
          {/* This content will be moved from AssessmentAnalytics */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <AssessmentAnalytics assessmentId={assessment.id} showOnlySummary />
          </div>
        </TabsContent>

        {/* Tab 2: Survey Result - Question Accordions */}
        <TabsContent value="survey" className="mt-2">
          <ConnectedAssessmentQuestionsTable assessmentId={assessment.id} />
        </TabsContent>
      </Tabs>
    </div>
  )
}
